import { render, staticRenderFns } from "./WaterGoldItem.vue?vue&type=template&id=cbb02582"
import script from "./WaterGoldItem.vue?vue&type=script&lang=js"
export * from "./WaterGoldItem.vue?vue&type=script&lang=js"
import style0 from "./WaterGoldItem.vue?vue&type=style&index=0&id=cbb02582&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports